module.exports = __webpack_public_path__ + "static/img/glkt.28c1dce8.png";